import CountUp from 'react-countup'
import React, { useEffect, useState, useRef } from "react"
import ReactDOM from 'react-dom'
import Blockchains from '@depay/web3-blockchains'

export default function Conversion3DScene(props) {

  function shuffleArray(arr) {
    // Copy the original array
    const a = arr.slice();
    // Walk backwards through the array
    for (let i = a.length - 1; i > 0; i--) {
      // Pick a random index from 0..i
      const j = Math.floor(Math.random() * (i + 1));
      // Swap positions i ↔ j
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  // all 12 composites: 8 two-point (single) and 4 three-point (double)
  const composites = shuffleArray([
    // single-rect (2 segments → 3 pts)
    { id: 'compositePathTL_ML', start: [150,150], type: 'single' },
    { id: 'compositePathML_BL', start: [150,300], type: 'single' },
    { id: 'compositePathBL_BM', start: [150,460], type: 'single' },
    { id: 'compositePathBM_BR', start: [300,460], type: 'single' },
    { id: 'compositePathBR_MR', start: [460,460], type: 'single' },
    { id: 'compositePathMR_TR', start: [460,300], type: 'single' },
    { id: 'compositePathTR_TM', start: [460,150], type: 'single' },
    { id: 'compositePathTM_TL', start: [300,150], type: 'single' },
    // two-rect (3 segments → 4 pts)
    { id: 'compositePathTL_BR', start: [150,150], type: 'double' },
    { id: 'compositePathTR_BL', start: [460,150], type: 'double' },
    { id: 'compositePathTL_BL', start: [150,150], type: 'double' },
    { id: 'compositePathTR_BR', start: [460,150], type: 'double' }
  ])

  // constants for timing
  const waveSize          = 12 // 3 dots per wave
  const waveInterval      = 4 // base seconds between wave starts
  const startStagger      = 0.5 // seconds between each dot start in a wave
  const animationDuration = 2 // each animateMotion dur="4s"
  const waveCount         = Math.ceil(composites.length / waveSize) // → 4 waves
  const pauseBeforeRepeat = waveCount * waveInterval - animationDuration // 16 - 4 = 12

  return (
    <div className="conversion-scene-container">

      <svg overflow="hidden" viewBox="10 10 600 600" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

        <defs>
          
          <clipPath id="conversionSceneTokenCircleClip">
            <circle cx="20" cy="20" r="20" />
          </clipPath>

          <path
            id="compositePathTL_ML"
            d="M150,150 L225,225 L150,300"
            fill="none"
          />
          <path
            id="compositePathML_BL"
            d="M150,300 L225,385 L150,460"
            fill="none"
          />
          <path
            id="compositePathBL_BM"
            d="M150,460 L225,385 L300,460"
            fill="none"
          />
          <path
            id="compositePathBM_BR"
            d="M300,460 L385,385 L460,460"
            fill="none"
          />
          <path
            id="compositePathBR_MR"
            d="M460,460 L385,385 L460,300"
            fill="none"
          />
          <path
            id="compositePathMR_TR"
            d="M460,300 L385,225 L460,150"
            fill="none"
          />
          <path
            id="compositePathTR_TM"
            d="M460,150 L385,225 L300,150"
            fill="none"
          />
          <path
            id="compositePathTM_TL"
            d="M300,150 L225,225 L150,150"
            fill="none"
          />

          <path
            id="compositePathTL_BR"
            d="M150,150 L225,225 L385,385 L460,460"
            fill="none"
          />
          <path
            id="compositePathTR_BL"
            d="M460,150 L385,225 L225,385 L150,460"
            fill="none"
          />
          <path
            id="compositePathTL_BL"
            d="M150,150 L225,225 L225,385 L150,460"
            fill="none"
          />
          <path
            id="compositePathTR_BR"
            d="M460,150 L385,225 L385,385 L460,460"
            fill="none"
          />

        </defs>

        <path className="conversion-scene-line" id="conversionSceneLineTopLeftCircToRect" d="M150,150 L225,225" fill="none" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        <path className="conversion-scene-line" id="conversionSceneLineTopLeftRectToCirc" d="M225,225 L300,150" fill="none" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>

        <path className="conversion-scene-line" id="conversionSceneLineTopLeftCircToRect" d="M150,150 L225,225" fill="none" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        <path className="conversion-scene-line" id="conversionSceneLineTopLeftRectToCirc" d="M225,225 L300,150" fill="none" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>

        <path className="conversion-scene-line" id="conversionSceneLineTopRightCircToRect" d="M300,150 L385,225" fill="none" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        <path className="conversion-scene-line" id="conversionSceneLineTopRightRectToCirc" d="M385,225 L460,150" fill="none" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>

        <path className="conversion-scene-line" id="conversionSceneLineBottomLeftCircToRect" d="M150,460 L225,385" fill="none" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        <path className="conversion-scene-line" id="conversionSceneLineBottomLeftRectToCirc" d="M225,385 L300,460" fill="none" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>

        <path className="conversion-scene-line" id="conversionSceneLineBottomRightCircToRect" d="M300,460 L385,385" fill="none" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        <path className="conversion-scene-line" id="conversionSceneLineBottomRightRectToCirc" d="M385,385 L460,460" fill="none" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>

        <path className="conversion-scene-line" id="conversionSceneLineMiddleLeftCircToTopLeftRect" d="M150,300 L225,225" fill="none" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        <path className="conversion-scene-line" id="conversionSceneLineMiddleLeftCircToBottomLeftRect" d="M150,300 L225,385" fill="none" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>

        <path className="conversion-scene-line" id="conversionSceneLineMiddleRightCircToTopRightRect" d="M460,300 L385,225" fill="none" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        <path className="conversion-scene-line" id="conversionSceneLineMiddleRightCircToBottomRightRect" d="M460,300 L385,385" fill="none" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>

        <path className="conversion-scene-line" id="conversionSceneLineTopLeftRectToBottomRightRect" d="M225,225 L385,385" fill="none" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        <path className="conversion-scene-line" id="conversionSceneLineTopRightRectToBottomLeftRect" d="M385,225 L225,385" fill="none" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>

        <path className="conversion-scene-line" id="conversionSceneLineTopLeftRectToTopRightRect" d="M225,225 L385,225" fill="none" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        <path className="conversion-scene-line" id="conversionSceneLineTopLeftRectToBottomLeftRect" d="M225,225 L225,385" fill="none" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>

        <path className="conversion-scene-line" id="conversionSceneLineTopRightRectToBottomRightRect" d="M385,225 L385,385" fill="none" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        <path className="conversion-scene-line" id="conversionSceneLineBottomLeftRectToBottomRightRect" d="M225,385 L385,385" fill="none" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>


        {composites.map((comp, i) => {
          // 1) which wave 0–3 is this in?
          const waveIndex       = Math.floor(i / waveSize)
          // 2) within that wave, is it the 0th, 1st or 2nd dot?
          const intraWaveIndex  = i % waveSize
          // 3) base wave start
          const waveStart       = waveIndex * waveInterval
          // 4) total begin time: waveStart + stagger, then loop
          const animId          = `anim_${comp.id}`
          const beginAttr       = `${waveStart + intraWaveIndex * startStagger}s;${animId}.end+${pauseBeforeRepeat}s`

          // keyTimes/keyPoints unchanged
          const keyTimes  = comp.type === 'single'
            ? '0;0.375;0.75;1'
            : '0;0.25;0.5;0.75;1'
          const keyPoints = comp.type === 'single'
            ? '0;0.5;1;1'
            : '0;0.333;0.667;1;1'

          return (
            <circle
              key={comp.id}
              r="3"
              fill="#ea357a"
              opacity="0.8"
            >
              <animateMotion
                id={animId}
                dur={`${animationDuration}s`}
                begin={beginAttr}
                keyTimes={keyTimes}
                keyPoints={keyPoints}
                fill="freeze"
                rotate="0"
              >
                <mpath xlinkHref={`#${comp.id}`} />
              </animateMotion>
            </circle>
          )
        })}

        <g id="conversionSceneBlockchainTopLeft" transform="translate(200,200)">
          <rect x="0" y="0" width="50" height="50" rx="10" ry="10" fill={Blockchains.ethereum.logoBackgroundColor}/> 
          <image href={Blockchains.ethereum.logo} x="5" y="5" width="40" height="40"/>
        </g>

        <g id="conversionSceneBlockchainTopRight" transform="translate(360,200)">
          <rect x="0" y="0" width="50" height="50" rx="10" ry="10" fill={Blockchains.solana.logoBackgroundColor}/> 
          <image href={Blockchains.solana.logo} x="5" y="5" width="40" height="40"/>
        </g>

        <g id="conversionSceneBlockchainBottomRight" transform="translate(360,360)">
          <rect x="0" y="0" width="50" height="50" rx="10" ry="10" fill={Blockchains.bsc.logoBackgroundColor}/> 
          <image href={Blockchains.bsc.logo} x="5" y="5" width="40" height="40"/>
        </g>

        <g id="conversionSceneBlockchainBottomLeft" transform="translate(200,360)">
          <rect x="0" y="0" width="50" height="50" rx="10" ry="10" fill={Blockchains.base.logoBackgroundColor}/> 
          <image href={Blockchains.base.logo} x="5" y="5" width="40" height="40"/>
        </g>

        <g id="conversionSceneTokenTopLeft" transform="translate(130,130)">
          <image clipPath="url(#conversionSceneTokenCircleClip)" href={Blockchains.ethereum.tokens[2].logo} x="0" y="0" width="40" height="40" rx="9999" ry="9999"/>
        </g>

        <g id="conversionSceneTokenTopMiddle" transform="translate(280,130)">
          <image clipPath="url(#conversionSceneTokenCircleClip)" href={Blockchains.ethereum.tokens[4].logo} x="0" y="0" width="40" height="40" rx="9999" ry="9999"/>
        </g>

        <g id="conversionSceneTokenTopMiddle" transform="translate(440,130)">
          <image clipPath="url(#conversionSceneTokenCircleClip)" href={Blockchains.solana.tokens[0].logo} x="0" y="0" width="40" height="40" rx="9999" ry="9999"/>
        </g>

        <g id="conversionSceneTokenTopMiddle" transform="translate(130,280)">
          <image clipPath="url(#conversionSceneTokenCircleClip)" href={Blockchains.ethereum.tokens[0].logo} x="0" y="0" width="40" height="40" rx="9999" ry="9999"/>
        </g>

        <g id="conversionSceneTokenTopMiddle" transform="translate(440,280)">
          <image clipPath="url(#conversionSceneTokenCircleClip)" href={Blockchains.solana.tokens[4].logo} x="0" y="0" width="40" height="40" rx="9999" ry="9999"/>
        </g>

        <g id="conversionSceneTokenTopMiddle" transform="translate(130,440)">
          <image clipPath="url(#conversionSceneTokenCircleClip)" href={Blockchains.ethereum.tokens[8].logo} x="0" y="0" width="40" height="40" rx="9999" ry="9999"/>
        </g>

        <g id="conversionSceneTokenTopMiddle" transform="translate(280,440)">
          <image clipPath="url(#conversionSceneTokenCircleClip)" href={Blockchains.ethereum.tokens[3].logo} x="0" y="0" width="40" height="40" rx="9999" ry="9999"/>
        </g>

        <g id="conversionSceneTokenTopMiddle" transform="translate(440,440)">
          <image clipPath="url(#conversionSceneTokenCircleClip)" href={Blockchains.bsc.tokens[0].logo} x="0" y="0" width="40" height="40" rx="9999" ry="9999"/>
        </g>

      </svg>

    </div>
  )
}
